import { useLocale } from '@app/core/hooks/useLocale';
import { ModalSize } from '@app/shared/components/modal/base-modal-enums';
import BaseModal from '@app/shared/components/modal/BaseModal';
import { FC } from 'react';

interface Props {
  visible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const DateChangeModal: FC<Props> = ({ visible, onConfirm, onCancel }) => {
  const { l } = useLocale();

  return (
    <BaseModal
      size={ModalSize.Small}
      title={l('_AssignToAllCases')}
      buttonConfirmLabel={l('_Apply')}
      buttonCancelLabel={l('_Cancel')}
      onCloseButtonClick={onCancel}
      onConfirm={onConfirm}
      onCancel={onCancel}
      isOpen={visible}>
      {l('_EventBeforeValuationDate')}
      <br />
      <br />
      {l('_WantToContinue')}
    </BaseModal>
  );
};

export default DateChangeModal;
